export const DATA_HOOKS = {
    base: 'floating-dropdown-base',
    baseSelectedValue: 'floating-dropdown-base-selected-value',
    coreDropdown: 'core-dropdown',
    nativeSelect: 'floating-dropdown-native-select',
    floatingDropdownButton: 'floating-dropdown-button',
};
//# sourceMappingURL=constants.js.map